import { Type } from 'class-transformer';
import {
  IsNotEmpty,
  IsArray,
  IsDateString,
  IsNumber,
  IsString,
  IsBoolean,
  IsOptional,
  IsIn,
  ValidateNested,
} from 'class-validator';

import { VacationUnitItem } from '@app/gen/vacations';

import { ValidatorGroup } from './validator-group.dto';
import { VacationApprover } from './vacation-approver.dto';

export class CreateVacationDto {
  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  companyIds: string[];

  @IsDateString()
  @IsNotEmpty()
  activeTo: string;

  @IsString()
  @IsNotEmpty()
  employeeCanSeeVacations: string;

  @IsString()
  @IsNotEmpty()
  allowEmployeeComment: string;

  @IsDateString()
  @IsNotEmpty()
  employeeDeadline: string;

  @IsBoolean()
  @IsNotEmpty()
  weekendExclusion: boolean;

  @IsBoolean()
  @IsNotEmpty()
  mustScheduleAllDays: boolean;

  @IsBoolean()
  @IsNotEmpty()
  mustSchedule14days: boolean;

  @IsBoolean()
  @IsNotEmpty()
  workingDay: boolean;

  @IsBoolean()
  @IsNotEmpty()
  limitToCalculatedDays: boolean;

  @IsString()
  @IsNotEmpty()
  addPreviousVacation: string;

  @IsNumber()
  @IsOptional()
  @Type(() => Number)
  minDurationDays: number;

  @IsString()
  @IsOptional()
  minDurationUnit: string;

  @IsBoolean()
  @IsNotEmpty()
  minDuration: boolean;

  @IsNumber()
  @IsOptional()
  @Type(() => Number)
  maxDurationDays: number;

  @IsString()
  @IsNotEmpty()
  maxDurationUnit: string;

  @IsBoolean()
  @IsNotEmpty()
  maxDuration: boolean;

  @IsBoolean()
  @IsNotEmpty()
  daysMustBeDivisibleBy: boolean;

  @IsNumber()
  @IsOptional()
  @Type(() => Number)
  daysMustBeDivisibleByNumber: number;

  @IsBoolean()
  @IsNotEmpty()
  min5DaysBetweenNotWorkdays: boolean;

  @IsBoolean()
  @IsOptional()
  minSpecificWeekendDays: boolean;

  @IsString()
  @IsOptional()
  companyComment: string;

  @IsString()
  @IsOptional()
  teammateAccess: 'unit' | 'all';

  @IsString()
  @IsNotEmpty()
  skipMissingManagers: string;

  @ValidateNested({ each: true })
  @Type(() => VacationApprover)
  @IsArray()
  @IsOptional()
  approvers: VacationApprover[];

  @ValidateNested({ each: true })
  @Type(() => ValidatorGroup)
  @IsArray()
  @IsOptional()
  validatorGroups?: ValidatorGroup[];

  @IsIn(['legal', 'operational'])
  @IsString()
  @IsOptional()
  unit_type?: 'legal' | 'operational';

  @ValidateNested({ each: true })
  @Type(() => VacationUnitItem)
  @IsArray()
  @IsOptional()
  unit_items?: VacationUnitItem[];

  @IsIn(['company', 'units', 'custom_type'])
  @IsString()
  @IsNotEmpty()
  type: 'company' | 'units' | 'custom_type';

  @IsString()
  @IsOptional()
  customType?: string;
}
